import ContractTemplatesPage from "./ContractTemplatesPage.vue";

export default [
    {
        path: "/contract-templates",
        name: "contract-templates",
        component: ContractTemplatesPage,
        meta: {
            requiresAuth: true
        }
    }
];
